import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DetailDocumentsComponent } from 'src/app/shared/components/detail-documents/detail-documents.component';
import { DOCUMENT_NAMES_TO_REMOVE } from 'src/app/shared/constants/card-documents.constants';
import { FEASIBILITY_KEYS } from 'src/app/shared/constants/common.constants';
import { UtilsService } from 'src/app/utils/utils.service';
import { CardRequestDetailService } from '../card-request-detail.service';
import { CardRequestDetailDocumentsService } from './card-request-detail-documents.service';

@Component({
    selector: 'app-card-request-detail-documents',
    templateUrl: './card-request-detail-documents.component.html',
    standalone: true,
    imports: [NgIf, Button, TooltipModule, AccordionModule, NgFor, DecimalPipe, TranslateModule, DetailDocumentsComponent]
})
export class CardRequestDetailDocumentsComponent {
    private readonly translate = inject(TranslateService);
    private readonly utilsService = inject(UtilsService);
    protected readonly cardRequestDetailDocumentsService = inject(CardRequestDetailDocumentsService);
    protected readonly cardRequestDetailService = inject(CardRequestDetailService);

    protected readonly feasibilityKeys: string[] = FEASIBILITY_KEYS;
    protected readonly documentNamesToRemove = DOCUMENT_NAMES_TO_REMOVE;

    protected translateFeasibilityKey(key: string): string {
	    return this.translate.instant(`FEASIBILITY_KEYS.${key}`);
    }

    protected isNumber(value: any): boolean {
	    return typeof value === 'number';
    }

    protected translateIfBoolean(value: any): string {
	    if (typeof value === 'boolean') {
	        return this.utilsService.translateBoolean(value);
	    } else {
	        return value;
	    }
    }
}
